export const dataHooks = {
    prefixIcon: 'button-prefix-icon',
    suffixIcon: 'button-suffix-icon',
};
//# sourceMappingURL=constants.js.map